import gql from 'graphql-tag'
import { allowedLanguages } from '@/translations'

export const eventCodeAdmin = gql`
  query eventCodeAdmin($id: ID!, $lang: String) {
    eventCodeAdmin(eventCodeId: $id) {
      id
      name
      severity
      ${allowedLanguages
        .map((lang) => `${lang}Description: description(lang: "${lang}")`)
        .join('\n')}
      disabled
      detectionPoint {
        id
        name
      }
      detectionMechanism
      terminationMechanism
      actionOnEvent
      deprecatedAt
      replacementEventCode { id name }
      supersededEventCode { id name }
      defaultNotificationClass {
        id
        notificationClass
      }
      coreCauses {
        id
        name
        description(lang: $lang)
      }
    }
  }
`
